// Patient results pages rebuilt from the old WordPress "Results" posts
// (category js-results). A post is rebuilt only when its old URL still has
// value: Search Console clicks in the last 12 months, or at least 1 referring
// domain in Ahrefs. Measured on 1 Oct 2026, only robert-l qualified (9
// referring domains to /results/robert-l/). The other patient slugs keep their
// 301 to /results/ (see legacy-results-slugs.ts).
//
// Each entry copies only what the old public page showed: the graft count,
// the first name and last initial, the job line, and the before and after
// photos. Anthony confirmed on 30 Sep 2026 that the photo releases allow
// publication. Do not add personal details that the old page did not show.

export type PatientResult = {
  /** URL slug: the page lives at /results/<slug>/. */
  slug: string;
  /** First name and last initial, as on the old page. */
  name: string;
  /** Job line from the old page. */
  role: string;
  /** Graft count line from the old page. */
  grafts: string;
  before: { src: string; alt: string };
  after: { src: string; alt: string };
  /** Meta description, 110 to 160 characters. */
  description: string;
  /** Date of the original WordPress post. */
  published: string;
};

export const PATIENT_RESULTS: PatientResult[] = [
  {
    slug: "robert-l",
    name: "Robert L.",
    role: "Sales",
    grafts: "3,000 Grafts",
    before: { src: "/images/results/robert-l-before.webp", alt: "Robert L. before his RESTORE hair transplant" },
    after: { src: "/images/results/robert-l-after.webp", alt: "Robert L. after his 3,000-graft RESTORE hair transplant" },
    description:
      "See before and after photos of Robert L., a RESTORE® Hair client who works in sales, after his 3,000-graft hair transplant.",
    published: "2024-02-28",
  },
];

export function findPatientResult(slug: string): PatientResult | undefined {
  return PATIENT_RESULTS.find((p) => p.slug === slug);
}
